import { actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  posDetail: {},
  posCount: null,
  posList: [],
  pos_groupsList: [],
  list_posList: [],
  posSequencesList: [],
  retrieveLoader: false,
  createLoader: false,
  deleteLoader: false
}

const getters = {
  orgunits: state => {
    return state.orgunitsList
  }
}

export default {
  actions: actionsAbstract,
  getters,
  mutations: mutationsAbstract,
  namespaced: true,
  state
}
